/* Theme-scoped presentation adapter. Uses existing provider click handlers;
   never changes global app settings, plan IDs, prices or cart API payloads. */
(() => {
  const script = document.querySelector('script[data-cro-cart-visual]');
  if (!script) return;
  const mode = script.dataset.protectionMode;
  const states = new WeakMap();
  const bridges = new WeakMap();

  function enhance(form) {
    const state = states.get(form);
    if (form.id === 'CartDrawerForm') {
      const rows = Array.from(form.querySelectorAll('[data-products] .cart__item:not([data-cro-protection-item])'));
      const keys = rows.map(row => row.dataset.key);
      if (state.knownKeys?.length) {
        const added = rows.find(row => !state.knownKeys.includes(row.dataset.key));
        if (added) state.addedVariant = added.dataset.key.split(':')[0];
      }
      state.knownKeys = keys;
      const count = Array.from(form.querySelectorAll('[data-products] .js-qty__num'))
        .reduce((sum, input) => sum + (Number(input.value) || 0), 0);
      form.querySelectorAll('[data-cro-cart-count]').forEach(el => {
        if (el.textContent !== String(count)) el.textContent = String(count);
      });
      const toggle = form.querySelector('[data-cro-items-toggle]');
      const items = form.querySelector('#CroCartItems');
      if (toggle && items) {
        items.hidden = !state.expanded;
        toggle.setAttribute('aria-expanded', String(!!state.expanded));
      }
      const recent = form.querySelector('[data-cro-added-item]');
      if (recent && state.addedVariant) {
        const row = Array.from(form.querySelectorAll('[data-products] .cart__item'))
          .find(el => el.dataset.key?.split(':')[0] === String(state.addedVariant));
        const title = row?.querySelector('.cart__item-name');
        const price = row?.querySelector('.cro-cart-line-total strong');
        const signature = row ? row.dataset.key + ':' + (price?.textContent || '') : '';
        if (!row) { recent.hidden = true; }
        else if (recent.dataset.signature !== signature) {
          recent.dataset.signature = signature;
          const badge = document.createElement('span'); badge.className = 'cro-added-badge'; badge.textContent = '✓ Item added';
          const info = document.createElement('div'); info.className = 'cro-added-info';
          const productUrl = title?.getAttribute('href');
          const source = row.querySelector('.cart__image img');
          if (source) {
            const image = document.createElement('img');
            image.src = source.currentSrc || source.getAttribute('src') || (source.dataset.src || '').replace('{width}', '180');
            image.alt = title?.textContent.trim() || '';
            if (productUrl) {
              const link = document.createElement('a'); link.href = productUrl; link.className = 'cro-added-image-link';
              link.append(image); info.append(link);
            } else { info.append(image); }
          }
          const copy = document.createElement('div');
          const titleText = title?.textContent.trim();
          if (titleText) {
            const line = document.createElement('div');
            if (productUrl) {
              const link = document.createElement('a'); link.href = productUrl; link.textContent = titleText;
              line.append(link);
            } else { line.textContent = titleText; }
            copy.append(line);
          }
          for (const text of [row.querySelector('.cart__item--variants')?.textContent.trim(), price?.textContent.trim()]) {
            if (text) { const line = document.createElement('div'); line.textContent = text; copy.append(line); }
          }
          info.append(copy); recent.replaceChildren(badge, info); recent.hidden = false;
        } else { recent.hidden = false; }
      }
    }

    const disclosure = form.querySelector('[data-cro-recommendations]');
    if (disclosure) {
      const slot = disclosure.querySelector('[data-cro-recommendations-slot]');
      const incoming = Array.from(form.querySelectorAll('lb-upsell-widget'))
        .filter(root => !slot.contains(root) && root.querySelector('.lb-addon-cont'));
      // Replace the previous presentation node if the app supplies a refreshed one.
      if (incoming.length === 1) slot.replaceChildren(incoming[0]);
      const hasOffer = !!slot.querySelector('lb-upsell-widget');
      if (disclosure.hidden === hasOffer) disclosure.hidden = !hasOffer;
      // Keep the provider's add flow for individual products; packs open their PDP.
      slot.querySelectorAll('.lb-product-card[lb-product-handle]').forEach(card => {
        const handle = card.getAttribute('lb-product-handle');
        const title = card.querySelector('.lb-card-title')?.textContent.trim() || '';
        const isPack = /(?:^|[-_\s])(?:\d+[-_\s]*)?packs?(?:$|[-_\s])|bundles?/i.test(`${handle} ${title}`);
        const action = card.querySelector('lb-button[lb-action-product]');
        if (!action) return;
        if (card.hasAttribute('data-cro-pack') !== isPack) card.toggleAttribute('data-cro-pack', isPack);
        let link = card.querySelector('.cro-view-pack');
        if (isPack) {
          if (!link) {
            link = document.createElement('a');
            link.className = 'cro-view-pack';
            link.textContent = 'View Pack';
            link.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}`;
            link.setAttribute('aria-label', `View ${title || 'Pack'}`);
            link.addEventListener('click', event => event.stopPropagation());
            action.after(link);
          }
        } else {
          link?.remove();
          const button = action.querySelector('.lb-button');
          if (button?.textContent.trim() === 'Add') {
            Array.from(button.childNodes).forEach(node => {
              if (node.nodeType === 3 && node.textContent.trim() === 'Add') node.textContent = 'Add to Cart';
            });
          }
        }
      });
      const track = slot.querySelector('.lb-carousel-products');
      const cards = track ? Array.from(track.children).filter(el => el.matches('[role="listitem"]')) : [];
      if (cards.length) {
        const step = cards.length > 1 ? Math.abs(cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left) : 1;
        const index = Math.max(0, Math.min(cards.length - 1, Math.round(Math.abs(track.scrollLeft) / (step || 1))));
        const position = disclosure.querySelector('[data-cro-recs-position]');
        const caption = `${index + 1} / ${cards.length}`;
        if (position && position.textContent !== caption) position.textContent = caption;
        const previous = disclosure.querySelector('[data-cro-recs-prev]');
        const next = disclosure.querySelector('[data-cro-recs-next]');
        if (previous && previous.disabled !== (index === 0)) previous.disabled = index === 0;
        if (next && next.disabled !== (index === cards.length - 1)) next.disabled = index === cards.length - 1;
      }
    }

    form.querySelectorAll('.ssp-checkout-link').forEach(link => {
      if (!link.hasAttribute('href') && !link.dataset.croKeyboard) {
        link.dataset.croKeyboard = 'true';
        link.setAttribute('role', 'button');
        link.setAttribute('tabindex', '0');
        link.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            link.click();
          }
        });
      }
    });
    if (!['opt_in', 'opt_out'].includes(mode)) return;
    form.querySelectorAll('.ssp-checkout-button-container.loaded').forEach(provider => {
      const primary = provider.querySelector('.ssp-checkout-button');
      const secondary = provider.querySelector('.ssp-checkout-link:not(.hideBox)');
      const plan = primary?.querySelector('.insurance_plan');
      if (!primary || !secondary || !plan?.textContent.trim()) return;
      let bridge = bridges.get(provider);
      if (bridge && (bridge.primary !== primary || bridge.secondary !== secondary)) {
        bridge.block.remove();
        provider.classList.remove('cro-actions-bridged');
        bridges.delete(provider);
        bridge = null;
      }
      if (!bridge) {
        const block = document.createElement('div');
        block.className = 'cro-provider-bridge';
        const choice = document.createElement('div');
        choice.className = 'cro-protection-choice';
        const label = document.createElement('label');
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.checked = state.choice ?? (!!form.querySelector('[data-cro-protection-item]') || mode === 'opt_out');
        state.choice = checkbox.checked;
        const text = document.createElement('span');
        label.append(checkbox, text);
        choice.append(label);
        const coverage = provider.querySelector('.toolltiptextCstm')?.textContent.trim();
        if (coverage) {
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          summary.textContent = 'View coverage';
          const body = document.createElement('p');
          body.textContent = coverage;
          details.append(summary, body);
          choice.append(details);
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cro-checkout-single';
        button.textContent = 'Continue to Checkout';
        checkbox.addEventListener('change', () => { state.choice = checkbox.checked; enhance(form); });
        button.addEventListener('click', () => {
          if (state.submitting) return;
          const terms = form.querySelector('.cart__terms-checkbox');
          if (terms && !terms.checked) { terms.focus(); return; }
          const target = checkbox.checked ? primary : secondary;
          if (!target.isConnected || primary.disabled) return;
          state.submitting = true;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          // Dispatch to the same action the shopper would otherwise click.
          target.click();
          // Provider retains navigation/cart mutation. Allow retry if it stalls.
          setTimeout(() => {
            if (!button.isConnected) return;
            state.submitting = false;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }, 15000);
        });
        block.append(choice, button);
        provider.append(block);
        provider.classList.add('cro-actions-bridged');
        bridge = {block, text, primary, secondary, checkbox};
        bridges.set(provider, bridge);
      }
      const caption = `Optional protection · ${plan.textContent.replace(/\s+/g, '').trim()}`;
      if (bridge.text.textContent !== caption) bridge.text.textContent = caption;
      bridge.checkbox.setAttribute('aria-label', caption.replace('Optional protection', 'Optional shipping protection'));

    });
  }

  for (const id of ['CartDrawerForm', 'CartPageForm']) {
    const form = document.getElementById(id);
    if (!form || !form.closest('.cro-cart-visual')) continue;
    states.set(form, {choice:null, submitting:false, expanded:false, addedVariant:null});
    const itemsToggle = form.querySelector('[data-cro-items-toggle]');
    itemsToggle?.addEventListener('click', () => {
      const state = states.get(form); state.expanded = !state.expanded;
      itemsToggle.innerHTML = state.expanded ? 'Hide items <span aria-hidden="true">⌃</span>' : 'View items <span aria-hidden="true">⌄</span>';
      enhance(form);
    });
    if (form.id === 'CartDrawerForm') document.addEventListener('ajaxProduct:added', event => {
      const product = event.detail?.product;
      const state = states.get(form);
      state.addedVariant = product?.variant_id || product?.id || null;
      state.expanded = false;
      if (itemsToggle) itemsToggle.innerHTML = 'View items <span aria-hidden="true">⌄</span>';
      refresh();
    });
    let queued = false;
    const refresh = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; enhance(form); });
    };
    const observer = new MutationObserver(refresh);
    observer.observe(form, {childList:true, subtree:true, attributes:true, attributeFilter:['class', 'disabled']});
    const recommendations = form.querySelector('[data-cro-recommendations]');
    if (recommendations) {
      const navigate = direction => {
        const track = recommendations.querySelector('.lb-carousel-products');
        const cards = track ? Array.from(track.children).filter(el => el.matches('[role="listitem"]')) : [];
        if (!track || cards.length < 2) return;
        const step = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
        track.scrollBy({left: direction * Math.abs(step), behavior: 'smooth'});
      };
      recommendations.querySelector('[data-cro-recs-prev]')?.addEventListener('click', () => navigate(-1));
      recommendations.querySelector('[data-cro-recs-next]')?.addEventListener('click', () => navigate(1));
      recommendations.addEventListener('scroll', refresh, true);
    }
    enhance(form);
  }
})();

/* CRO measurement v1. No purchase/checkout-started emitter, storage or personal data. */
(() => {
  if (window.SleefsCRO) return;
  const counts = Object.create(null);
  const preview = !!window.Shopify?.designMode || !!window.Shopify?.previewMode ||
    (!!window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') ||
    new URLSearchParams(location.search).has('preview_theme_id');
  const qa = new URLSearchParams(location.search).get('cro_measurement_qa') === '1';
  function emit(name) {
    try {
      if ((preview && !qa) || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() ||
          typeof window.clarity !== 'function') return false;
      const event = qa ? name.replace('cro_', 'cro_qa_') : name;
      window.clarity('event', event);
      counts[event] = (counts[event] || 0) + 1;
      return true;
    } catch (_) { return false; }
  }
  // Counts contain only event names and numbers; useful for QA without payload logging.
  window.SleefsCRO = { version: '1.0.0', counts };
  const drawer = document.getElementById('CartDrawer');
  const ctaSelector = '.cro-checkout-single, .ssp-checkout-button, .ssp-checkout-link, [name="checkout"]';
  let open = false, opened = false, viewed = false, frame = 0;

  function visible(el) {
    if (!el || !el.isConnected || document.visibilityState !== 'visible') return false;
    for (let p = el; p; p = p.parentElement) {
      const style = getComputedStyle(p);
      if (p.hidden || p.getAttribute('aria-hidden') === 'true' || style.display === 'none' ||
          style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    const r = el.getBoundingClientRect();
    const left = Math.max(0, r.left), right = Math.min(innerWidth, r.right);
    const top = Math.max(0, r.top), bottom = Math.min(innerHeight, r.bottom);
    if (r.width <= 0 || r.height <= 0 || right <= left || bottom <= top ||
        (right-left)*(bottom-top) < r.width*r.height*0.5) return false;
    // Occlusion check: DOM presence/intersection alone can count behind a modal.
    const hit = document.elementFromPoint((left+right)/2, (top+bottom)/2);
    return !!hit && (hit === el || el.contains(hit));
  }
  function sync() {
    frame = 0;
    const now = !!drawer?.classList.contains('drawer--is-open');
    if (!now) { open = opened = viewed = false; return; }
    if (!open) { open = true; opened = viewed = false; }
    // Use a visible descendant: drawer itself can contain empty/background hit areas.
    const heading = drawer.querySelector('.drawer__title, .js-drawer-close, [data-cro-cart-count]');
    if (!opened && visible(heading)) opened = emit('cro_cart_open');
    if (opened && !viewed && Array.from(drawer.querySelectorAll(ctaSelector)).some(visible)) {
      viewed = emit('cro_cart_checkout_view');
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
  if (drawer) {
    new MutationObserver(schedule).observe(drawer, { subtree: true, childList: true,
      attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-hidden'] });
    drawer.addEventListener('transitionend', schedule);
    drawer.addEventListener('scroll', schedule, true);
    document.addEventListener('drawerOpen.CartDrawer', schedule);
    // Detect close immediately, including a rapid close/reopen in one animation frame.
    new MutationObserver(() => {
      if (!document.documentElement.classList.contains('js-drawer-open')) {
        open = opened = viewed = false;
      }
      schedule();
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  window.addEventListener('resize', schedule);
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('visitorConsentCollected', schedule);
  // Recheck after late Clarity loading or overlays outside the drawer; no history replay.
  setInterval(() => { if (open && document.visibilityState === 'visible') schedule(); }, 500);
  document.addEventListener('click', event => {
    // Programmatic provider proxy clicks must not duplicate the shopper's click.
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const cta = event.target.closest(ctaSelector);
    const form = cta?.closest('#CartDrawerForm, #CartPageForm');
    if (!form || cta.disabled || cta.getAttribute('aria-disabled') === 'true' || !visible(cta)) return;
    if (form.id === 'CartDrawerForm') sync();
    emit(form.id === 'CartDrawerForm' ? 'cro_cart_checkout_click' : 'cro_cart_page_checkout_click');
  }, true);
  // These callbacks follow successful HTTP add results in the current theme/quick add.
  document.addEventListener('ajaxProduct:added', event => {
    if (event.detail?.product?.id || event.detail?.product?.variant_id) emit('cro_atc_success');
  });
  // No free-text error messages leave the page.
  document.addEventListener('ajaxProduct:error', () => emit('cro_atc_error'));
  document.addEventListener('cro:atc-error', () => emit('cro_atc_error'));
  schedule();
})();
